import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '../../atoms';
import { styled } from '../../legacy/utils';
export const MultiTab = ({ tab, activeTab, }) => {
    const isSelectedTab = tab.id === activeTab;
    return (_jsxs(Stack, { direction: "column", gap: 102, children: [_jsx(Typography, { variant: "body1 light", color: "darkBlue", children: tab.header }), _jsxs(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", children: [_jsx(TypoStyled, { variant: "h5", color: isSelectedTab ? 'zurichBlue' : 'darkBlue', children: tab.text }), tab.tag && _jsxs(_Fragment, { children: [" ", tab.tag] })] })] }));
};
const TypoStyled = styled(Typography)(({ theme }) => ({
    [theme.breakpoints.up('lg')]: {
        fontSize: '1.375rem',
    },
}));
